import { jsx } from 'react/jsx-runtime';
import { InputText } from '../InputText/InputText.js';

function InputPassword({ name, label, placeholder, description, rules, value, defaultValue, disabled, autoComplete, onChange, }) {
    return (jsx(InputText, { type: "password", name: name, label: label !== null && label !== void 0 ? label : "Password", placeholder: placeholder, description: description, rules: rules, value: value, defaultValue: defaultValue, disabled: disabled, autoComplete: autoComplete, onChange: onChange }));
}

export { InputPassword };
//# sourceMappingURL=InputPassword.js.map
